export default __webpack_public_path__ + "static/media/bazzle_m_2.b61db130.png";